import { ApiErrorMessage, BaseApi } from "api";
import { endpoints } from "config";
import { MeasureParams, MeasureResponse } from "./measureModels";

class MeasureApi extends BaseApi {
  private static getMeasurementParseError: typeof this.parseGenericErrorMessageCode =
    (msg) => {
      switch (msg) {
        // API-specific error codes here, generic messages handled below
        case "At_Least_2_Points_Required":
          return "At least 2 points are required for measurement";
        case "Invalid_Ath":
        case "Invalid_Atv":
        case "Invalid_Coordinates":
          return "Invalid coordinates";
        default:
          return this.parseGenericErrorMessageCode(msg);
      }
    };

  /**
   * # Get the coordinates of a point in the panorama
   */
  static getMeasurement = async (payload: MeasureParams) => {
    try {
      const result = await this.makeRequest<
        MeasureResponse,
        ApiErrorMessage[],
        MeasureParams
      >({
        url: endpoints.features.measure,
        method: "POST",
        payload,
      });
      if (this.isResponseSuccessful(result)) {
        return this.successResponse(result.data.details);
      } else {
        return this.errorResponse(
          this.getMeasurementParseError(result.data.errors[0].message_code)
        );
      }
    } catch (err: unknown) {
      return this.safelyCatchUnknownError<MeasureResponse>(
        err,
        "getMeasurement",
        this.getMeasurementParseError
      );
    }
  };
}

export default MeasureApi;
